import { Injectable } from "@angular/core";
import * as CryptoTS from 'crypto-ts';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class EncryptionService {
  private key = CryptoTS.enc.Utf8.parse(environment.ENVIRONMENT.Key);
  private iv = CryptoTS.enc.Utf8.parse(environment.ENVIRONMENT.Iv);
  constructor() {}
  // Methods for the encrypt and decrypt Using AES
  encryptUsingAES256(text:any): any {
    let value = JSON.stringify(text)
      var encrypted = CryptoTS.AES.encrypt(CryptoTS.enc.Utf8.parse(value), this.key, {
          iv: this.iv,
          mode: CryptoTS.mode.CBC,
          padding: CryptoTS.pad.PKCS7
      });
      return encrypted.toString();
  }
  decryptUsingAES256(decString: any) {
    try{
      var decrypted = CryptoTS.AES.decrypt(decString, this.key, {
        iv: this.iv,
        mode: CryptoTS.mode.CBC,
        padding: CryptoTS.pad.PKCS7
    });
    return JSON.parse(decrypted.toString(CryptoTS.enc.Utf8));
    } catch (error) {
      console.log("Error during decryption:", error);
      return null;
    }
  }
}